module.exports = __webpack_public_path__ + "img/ground-material.8d46701e.jpg";